import ActionType from 'actions/ActionType'

export default (state = {}, action) => {
  const switchObj = {
    [ActionType.View.TOGGLE_DIALOG]: () => {
      if (
        action.payload?.dialog === 'AdvancedSearch' &&
        action.payload?.options?.sort &&
        action.payload?.options?.keys
      ) {
        const keys = action.payload.options.keys?.reduce((acc, el) => {
          acc[el] = true
          return acc
        }, {})

        const nonSortableKeys = action.payload.options.nonSortableKeys?.reduce(
          (acc, el) => {
            acc[el] = true
            return acc
          },
          {},
        )

        return {
          ...state,
          [action.payload.options.sort]: {
            ...(keys || {}),
            ...(nonSortableKeys || {}),
            ...(state?.[action.payload.options.sort] || {}),
          },
        }
      }

      return state
    },
    [ActionType.View.TOGGLE_ADVANCED_SEARCH_CHECKBOX]: () => {
      if (
        action.payload?.property &&
        typeof action.payload?.checked === 'boolean' &&
        action.payload?.sort
      ) {
        return {
          ...state,
          [action.payload.sort]: {
            ...state[action.payload.sort],
            [action.payload.property]: action.payload.checked,
          },
        }
      }
      return state
    },
  }

  // If the function returns falsey, a ternary is required because
  // if `|| state` is used, state will remain the same
  return switchObj?.[action?.type] ? switchObj[action?.type]() : state
}
